import { Box, Container, Typography } from '@mui/material';

interface Props {
  children?: React.ReactElement<unknown>;
  title: string
  subTitle?: string
}

export default function ContentHeader(props: Props) {
  return (
    <Box sx={(theme) => {
      return (
        {
          color: theme.palette.grey[50],
          width: '100%',
        }
      )
    }}>
      <Container>
        <Typography variant="h1" sx={(theme) => {
          return (
            {
              padding: '1rem 0.5rem 0 0',
              fontWeight: 'bold',
              fontSize: '3rem',
              [theme.breakpoints.up('md')]: {
                fontSize: '4rem',
              },
              [theme.breakpoints.up('lg')]: {
                fontSize: '5rem',
              },
            }
          )
        }}>
          {props.title}
        </Typography>
        <Typography variant="h1" sx={(theme) => {
          return (
            {
              padding: '0.5rem 0.5rem 1rem 0.25rem',
              fontWeight: 'bold',
              fontSize: '1rem',
              [theme.breakpoints.up('md')]: {
                fontSize: '1.1rem',
              },
              [theme.breakpoints.up('lg')]: {
                fontSize: '1.25rem',
              },
            }
          )
        }}>
          {props.subTitle}
        </Typography>
      </Container>
    </Box >
  );
}